import React from 'react';
import T from 'prop-types';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, styled, tableCellClasses } from '@mui/material';
import Split, { SplitHit } from '../../types/split';
import Run from '../../types/run';

import styles from './statistics.components.module.scss';
import { sortByOrder } from '../../utils/utils';
import Game from '../../types/game';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function GameTable({ game, logo, totalRuns = [], splits = [], onSplitHitClick }: { game: Game, logo: string, totalRuns: Run[], splits: Split[], onSplitHitClick: any }) {
  /** TODO: check if a type fits here */
  const displayRow = ({ splitId, splitName, splitHits, totalHits }: { splitId: number, splitName: string, splitHits: SplitHit[], totalHits: number}) => {
    const hasHit = (totalHits > 0);
    return (
      <StyledTableRow className={`${styles.row} ${hasHit ? styles.hit : ''}`} key={splitId} onClick={() => {
        if (hasHit) onSplitHitClick(splitHits)
      }}>
        <TableCell sx={{ fontSize: 18, maxWidth: 100, color: hasHit ? 'red' : 'inherit'}} colSpan={3} className={styles.split}>{splitName}</TableCell>
        <TableCell sx={{fontSize: 18, color: hasHit ? 'red' : 'inherit'}} colSpan={1} className={styles.accumulator}>{totalHits}</TableCell>
      </StyledTableRow>
    )
  }
  const displayRowPerSplit = (totalRuns : Run[], splits: Split[]) => {
    const sortedSplits = splits.sort(sortByOrder);
    return sortedSplits.map(split => {
      let totalHits = 0;
      let splitHits = [] as SplitHit[];
      const {name: splitName, id: splitId } = split;
      totalRuns.forEach(run => {
        if (split.id === run.splitHit && run.includesHit) {
          totalHits += 1;
          splitHits.push({ name: split.name, clip: run.clip, date: run.date });
        }
      });
      return displayRow({ splitId, splitName, splitHits, totalHits });
    });
  };
  return (
    <TableContainer className={`${styles.table} ${styles.splits}`} component={Paper} >
      <Table sx={{ width: 190 }} size='small'>
        <TableHead>
          <TableRow>
          <StyledTableCell className={styles.logoContainer} sx={{ textAlign: "center", fontSize: 26 }} colSpan={4}>{game.name}</StyledTableCell>          </TableRow>
        </TableHead>
        <TableBody>
          {displayRowPerSplit(totalRuns, splits)}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

GameTable.propTypes = {
  gameShortName: T.string,
  logo: T.string,
  onSplitHitClick: T.func,
  splits: T.array,
  totalRuns: T.array
};

export default GameTable;